export default "__VITE_ASSET__CZrRgS4___"